"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlackIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class SlackIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M15,7 L15,5.5 C15,4.67157288 15.6715729,4 16.5,4 C17.3284271,4 18,4.67157288 18,5.5 L18,7 L18.5,7 C19.3284271,7 20,7.67157288 20,8.5 C20,9.32842712 19.3284271,10 18.5,10 L18,10 L18,14 L18.5,14 C19.3284271,14 20,14.6715729 20,15.5 C20,16.3284271 19.3284271,17 18.5,17 L18,17 L18,18.5 C18,19.3284271 17.3284271,20 16.5,20 C15.6715729,20 15,19.3284271 15,18.5 L15,17 L9,17 L9,18.5 C9,19.3284271 8.32842712,20 7.5,20 C6.67157288,20 6,19.3284271 6,18.5 L6,17 L5.5,17 C4.67157288,17 4,16.3284271 4,15.5 C4,14.6715729 4.67157288,14 5.5,14 L6,14 L6,10 L5.5,10 C4.67157288,10 4,9.32842712 4,8.5 C4,7.67157288 4.67157288,7 5.5,7 L6,7 L6,5.5 C6,4.67157288 6.67157288,4 7.5,4 C8.32842712,4 9,4.67157288 9,5.5 L9,7 L15,7 Z M15,10 L9,10 L9,14 L15,14 L15,10 Z" })))));
    }
}
exports.SlackIcon = SlackIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/slack.tsx
// module id = 2165
// module chunks = 0 1 2